"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWizardSummary = exports.StyledWizardSummaryFieldset = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../helpers");
const Fieldset_1 = require("./components/Fieldset/Fieldset");
const FieldsetTitle_styles_1 = require("./components/FieldsetTitle/FieldsetTitle.styles");
const constants_1 = require("./helpers/constants");
exports.StyledWizardSummaryFieldset = (0, styled_components_1.default)(Fieldset_1.Fieldset) `
    font-size: ${helpers_1.FONT_SIZE_M};
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    color: ${({ theme }) => theme.colorTextMain};

    &:first-child ${FieldsetTitle_styles_1.StyledFieldsetTitle} td {
        padding-top: 0;
    }
`;
exports.StyledWizardSummary = styled_components_1.default.table `
    width: calc(
        100% +
            ${Math.abs(parseInt(constants_1.stylesConfig.marginLeft, 10)) +
    Math.abs(parseInt(constants_1.stylesConfig.marginRight, 10))}px
    );
    border-collapse: collapse;
    margin-left: ${constants_1.stylesConfig.marginLeft};
    margin-bottom: ${constants_1.stylesConfig.marginBottom};
`;
//# sourceMappingURL=WizardSummary.styles.js.map